import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { filterGrid } from 'helpers/decorators'
import { Input, Select } from 'components/fields'
import { Module, Row, Col, FilterActions } from 'components/misc'
import { apiCodeLists, apiConfiguration, apiLabels } from 'helpers/decorators/api'
import { getActiveRole } from 'utils/token'
import { CONFIGURATION_KEYS, LABEL_CATEGORY_TYPES, ROLES } from 'constants/enums'
import { get, isEmpty } from 'lodash'
import { mapLabels } from '../../../helpers/mapForSelect'
import * as leadersOverviewApi from '../../../redux/modules/api/leadersOverview'
import { injectIntl } from 'react-intl'

// send participant-related redux data
@apiCodeLists(['personStates'])
@apiConfiguration()
@apiLabels()
@connect(
  ({ api, auth }) => ({
    currentFilter: api.leadersOverview.filter,
    activeOrganization: auth.organization
  }),
  { setFilter: leadersOverviewApi.setLeadersOverviewFilter }
)
@filterGrid({
  form: 'leaders-overview-filter',
  persist: true,
  defaultFilter: {
    // eslint-disable-next-line camelcase
    'personState@eq': 'ACTIVE'
  }
})
@injectIntl
class   FilterLeadersOverview extends Component {
  static propTypes = {
    codeLists: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    searchLabels: PropTypes.func.isRequired,
    configuration: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired
  }

  searchOrganizationLeadersLabels = search => {
    const { intl } = this.props
    const params = { limit: 50 }

    if (search && search.name) {
      params.filter = `or(name ic ${search.name})`
    }

    const orgId = get(this.props.activeOrganization, 'id')
    return this.props.searchLabels(LABEL_CATEGORY_TYPES.CONTACT.id, params, orgId)
        .then(obj => obj.body)
        .then(obj => mapLabels(obj, false, true, intl))
  }

  render() {
    const { codeLists, activeOrganization, configuration, currentFilter } = this.props

    const isContactLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableContactLabels.id}].booleanValue`)

    const isLeader = getActiveRole(activeOrganization) === ROLES.LEADER.u

    const anyFilterSet = !isEmpty(currentFilter)

    return (
      <Module verticallyNarrow primary>
        <Row alignItems="center" gutters inner>
          <Col flex="0 1 200px">
            <Input
              label="Search"
              name="search@like"
              intlKey="label.search"
              clearable
            />
          </Col>
          <Col flex="0 1 200px">
            <Input
              label="Award Unit"
              name="organization_name@like"
              intlKey={
                getActiveRole(activeOrganization) === ROLES.GBT.u
                  ? 'label.independent_award_centre'
                  : 'label.award_unit'
              }
              clearable
            />
          </Col>
          <Col flex="0 1 200px">
            <Select
              label="Status"
              name="personState@eq"
              intlKey="label.status"
              options={codeLists.personStates.list}
            />
          </Col>
          {isContactLabelsEnabled && !isLeader && <Col flex="0 1 120px">
            <Select
              label="Award Leader Label"
              intlKey="label.contact_label"
                name="leaderLabel@or"
                multi
                autocomplete
                promise={this.searchOrganizationLeadersLabels}
                placeholder="Start typing ..."
                intlKeyPlaceholder="placeholder.start_typing"
                backspaceToRemoveMessage={''}
            />
          </Col>}
          <Col flex="1 1 auto" alignSelf="flex-end" right>
            <FilterActions {...this.props} count={null} query={anyFilterSet} />
          </Col>
        </Row>
      </Module>
    )
  }
}

export default FilterLeadersOverview
